import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogWrapperComponent } from './dialog-wrapper.component';

@Component({
    template: ''
})
export abstract class DialogSubscriptionComponent implements OnDestroy {
    subscriptions: Array<SubscriptionDialog>;

    private init() {
        this.subscriptions = this.subscriptions ? this.subscriptions : [];
    }

    private cleanUp() {
        if (this.subscriptions?.length) {
            this.subscriptions.forEach((s) => {
                if (!s.dialog || s.dialog.getState() === MatDialogState.CLOSED) {
                    s.subscription.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.cleanUp();
    }

    addSubscription(sub: Subscription, dialog: MatDialogRef<DialogWrapperComponent, any>) {
        this.init();
        this.cleanUp();
        this.subscriptions.push({
            subscription: sub,
            dialog: dialog
        });
    }
}

export class SubscriptionDialog {
    subscription: Subscription;
    dialog: MatDialogRef<DialogWrapperComponent, any>;
}
